import HomeFeaturesSection from './home-features-section'

export default HomeFeaturesSection
